import { Text } from '@react-pdf/renderer'
import React from 'react'

import type { PdfStyles } from './PdfPrimitives'

export function PdfMissing({
  styles,
}: {
  styles: PdfStyles
}): React.ReactElement {
  return <Text style={styles.missing}>***</Text>
}
